module.exports = __webpack_public_path__ + "img/download.bfde5e13.png";